import { z } from "zod";

export const ClaudeRunKindSchema = z.enum(["projectGeneration", "chat", "presentation"]);
export const ClaudeRunStatusSchema = z.enum(["pending", "running", "succeeded", "failed", "cancelled"]);
export const ClaudeRunLogStatusSchema = z.enum(["collecting", "stored", "failed"]);

export type TClaudeRunKind = z.infer<typeof ClaudeRunKindSchema>;
export type TClaudeRunStatus = z.infer<typeof ClaudeRunStatusSchema>;

export const LogFileSchema = z.object({ name: z.string(), bytes: z.number() });
export type TLogFile = z.infer<typeof LogFileSchema>;

export const ClaudeRunSchema = z.object({
  id: z.string(),
  createdAt: z.coerce.date(),
  kind: ClaudeRunKindSchema,
  status: ClaudeRunStatusSchema,
  organizationId: z.number(),
  projectId: z.number().nullable(),
  userId: z.number().nullable(),
  generationTaskId: z.number().nullable(),
  mode: z.string(),
  launch: z.string(),
  model: z.string().nullable(),
  effort: z.string().nullish(),
  skill: z.string(),
  error: z.string().nullable(),
  startedAt: z.coerce.date().nullable(),
  finishedAt: z.coerce.date().nullable(),
  estCostUsd: z.number().nullable(),
  assistantTurns: z.number().nullable(),
  toolCalls: z.number().nullable(),
  logStatus: ClaudeRunLogStatusSchema.nullable(),
  logFiles: z.array(LogFileSchema),
  logBytes: z.number().nullable(),
  logStoredAt: z.coerce.date().nullable(),
  logError: z.string().nullable(),
  user: z.object({ id: z.number(), firstName: z.string(), lastName: z.string(), email: z.string() }).nullable(),
  project: z.object({ id: z.number(), name: z.string() }).nullable(),
  organization: z.object({ id: z.number(), name: z.string() }),
  projectUrl: z.string().nullable(),
  userMessage: z.string().nullable()
});
export type TClaudeRun = z.infer<typeof ClaudeRunSchema>;

export const ClaudeRunDetailsSchema = ClaudeRunSchema.extend({
  generationTask: z.object({ id: z.number(), status: z.string(), phase: z.string().nullable() }).nullable(),
  chatTask: z.object({ canEdit: z.boolean(), status: z.string(), appliedChapters: z.unknown() }).nullable()
});
export type TClaudeRunDetails = z.infer<typeof ClaudeRunDetailsSchema>;

export const ClaudeRunsListSchema = z.object({ runs: z.array(ClaudeRunSchema), total: z.number() });

export const ClaudeRunsFiltersSchema = z.object({
  organizations: z.array(z.object({ id: z.number(), name: z.string() }))
});

export type TClaudeRunsQuery = {
  organizationId: string;
  userId: string;
  projectId: string;
  kind: string;
  status: string;
  from: string;
  to: string;
};

export const EMPTY_QUERY: TClaudeRunsQuery = {
  organizationId: "",
  userId: "",
  projectId: "",
  kind: "",
  status: "",
  from: "",
  to: ""
};

export const RUN_KIND_LABEL: Record<TClaudeRunKind, string> = {
  projectGeneration: "Generation",
  chat: "Leo chat",
  presentation: "Presentation"
};
